import { Edit, Remove } from "@app/components/Actions";
import pathRoutes from "../../../../routes/pathRoutes";
import { useMasterTables } from "../useMasterTables";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "@app/pages/users/utils/helpers";

export const columnsDetector = (keysTables: string[], tableName: string) => [
  {
    field: "id",
    headerName: "ID",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "name",
    headerName: "Detector",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "equipo",
    headerName: "Equipo",
    headerAlign: "center",
    align: "left",
    flex: 1,
    renderCell: (params: any) => (
      <div>{`${params.row.equipment?.codigo} ${params.row.equipment?.descripcion}`}</div>
    ),
    valueGetter: (params: any) =>
      `${params.row.equipment?.codigo || ''}`,
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    align: "left",
    flex: 1,
    renderCell: (params: any) => (
      <>
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Edit
            to={`${pathRoutes.ADMIN_MASTER_TABLES}/editar/${tableName}/${params.id}`}
          />
          <Remove
            onRemove={() =>
              useMasterTables.getState().deleteData(params.id, tableName)
            }
            title="Va a borrar de forma permanente este registro"
            text="¿Quiere continuar?"
          />
        </PermissionComponentGate>
      </>
    ),
  },
];
